




import { Component, Vue } from 'vue-property-decorator'
import CalculateStore from '@/stores/CalculateStore'

@Component
export default class PriceField extends Vue {
  get price(): number | null {
    return CalculateStore.price
  }

  set price(value: number | null) {
    CalculateStore.setPrice(value)
  }

  get priceLabel(): string {
    return `Цена, ${CalculateStore.currency.symbol}`
  }
}
